import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations, isEmpty, electOwningCase } from '../../../utils';
import { delCookie } from '../../../utils/cookie';
// restClient
import { eapiClient, aemHostClient } from '../../../restClient';
//action Creator
import { logOutUser } from '../../../actions/auth';
import { resetStore } from '../../../actions/actionCreator';
import { setLanguage, setTranslatedData, setLanguageFlag } from '../actions/actionCreator';
import { getDarkTitleBarFlagOnPassword, setDarkTitleBarContent, setHeaderDetails, setFooterDetails } from '../../layouts/actions/actionCreator';
import { getDarkTitleBarFlag } from '../../CaseBody/actions/actionCreator';
import { blockUi, unBlockUi } from '../../../actions/actionCreator';

import { getlanguageToggleValues } from '../../Login/json_login-in.js'

class RightSection extends Component {

  state = {
    arrowIsOpen: false,
    display: 'none',
    languagename: ['Language: English', 'Language: Spanish', 'Language: Bahasa'],
    index: 0,
    lastLogin: '',
    username: ''
  }

  logout = () => {
    if (!isEmpty(this.props.cases)) {
      let caseId = this.props.owningCase.caseId;
      if (caseId === undefined || caseId === null) {
        caseId = window.localStorage.getItem('owningCase');
      }
      const pageUrl = window.location.pathname;
      let apiURL = "/cases/" + caseId + '/exitCase';
      var METHOD = 'PUT';
      eapiClient(apiURL, {
        method: METHOD,
        timeout: 100000,
        data: { pageUrl: pageUrl, event: "Logout button click" }
      })
        .then(({ data }) => {
          window.localStorage.removeItem('owningCase');
          window.localStorage.removeItem('token');
          window.localStorage.removeItem('customer');
          window.localStorage.removeItem('tab');
          this.appLogout();
        });
    } else {
      this.appLogout();
    }
  }


  appLogout = () => {
    eapiClient("/users/logout", {
      method: 'POST'
    })
      .then(({ data, status }) => {
        if (status === 200) {
          if (this.props.customer !== 'undefined' && this.props.customer.roleDetails.customer) {
            this.props.history.push('/login');
          }
          else {
            this.props.history.push('/logout');
          }
          this.props.resetStore(null);
          this.props.logOutUser();
          if (this.props.history.location.pathname === '/logout') {
            this.setState({
              index: 0
            })
          }
          delCookie('expiration');
        }
      })
      .catch(error => {
        this.props.resetStore(null);
        this.props.logOutUser();
      });
  }

  handleWindowClick = () => {
    this.setState({
      display: 'none',
      arrowIsOpen: false
    });
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleWindowClick);
  }
  componentWillMount() {

    // if(this.props.history.location.pathname === '/staff-login'){
    //   aemHostClient('/aemData/formData/json_en-gb')
    //   .then(({data}) => {
    //     this.props.setTranslatedData(data)
    //   })
    // }
  }

  componentDidMount() {
    window.addEventListener('click', this.handleWindowClick);
  }

  openHander = (e) => {
    e.stopPropagation();
    if (this.state.arrowIsOpen === true && this.state.display === 'block') {
      document.getElementsByClassName("gdoc-header-pdiv-lan")[0].setAttribute("aria-expanded", "false");
      this.setState({
        arrowIsOpen: false,
        display: 'none'
      });
    } else {
      document.getElementsByClassName("gdoc-header-pdiv-lan")[0].setAttribute("aria-expanded", "true");
      this.setState({
        arrowIsOpen: true,
        display: 'block'
      });
    }
  }

  openHanderOnEnter = (e) => {
    if (e.keyCode === 13) {
      let wTile = e.target;
      if (this.state.arrowIsOpen === true && this.state.display === 'block') {
        document.getElementsByClassName("gdoc-header-pdiv-lan")[0].setAttribute("aria-expanded", "false");
        this.setState({
          arrowIsOpen: false,
          display: 'none'
        })
      } else {
        document.getElementsByClassName("gdoc-header-pdiv-lan")[0].setAttribute("aria-expanded", "true");
        this.setState({
          arrowIsOpen: true,
          display: 'block'
        })
      }
    }
  }

  setLanguage = (e) => {
    this.props.blockUi();
    document.getElementsByClassName("gdoc-header-pdiv-lan")[0].setAttribute("aria-expanded", "false");
    let apiUrl = '';
    var lang;
    this.setState({
      language: e.target.getAttribute('data-value'),
      arrowIsOpen: false,
      display: 'none'
    });
    if (e.target.getAttribute('data-value').split(":")[1].trim() === 'English' ||
      e.target.getAttribute('data-value').split(":")[1].trim() === 'Ingles' ||
      e.target.getAttribute('data-value').split(":")[1].trim() === 'Inggris') {
      this.setState({
        index: 0
      })
      apiUrl = '/aemData/formData/json_en-gb';
      lang = 'English'
    } else if (e.target.getAttribute('data-value').split(":")[1].trim() === 'Spanish'
      || e.target.getAttribute('data-value').split(":")[1].trim() === 'Espanol'
      || e.target.getAttribute('data-value').split(":")[1].trim() === 'Spanyol') {
      apiUrl = '/aemData/formData/json_en-es';
      lang = 'Spanish'
      this.setState({
        index: 1
      })
    } else if (e.target.getAttribute('data-value').split(":")[1].trim() === 'Bahasa') {
      apiUrl = '/aemData/formData/json_id'
      lang = 'Bahasa'
      this.setState({
        index: 2
      })
    }

    aemHostClient(apiUrl)
      .then(({ data }) => {
        this.props.setTranslatedData(data);
        this.props.setLanguage(lang);
        if (this.props.newPasswordFlag === 1) {
          // Dark title bar
          aemHostClient("/aemData/formData/json_dark-title-bar")
            .then(({ data, status }) => {
              this.props.getDarkTitleBarFlagOnPassword(0);
              this.props.setDarkTitleBarContent(Translations(data.par.static_text_darkTitleBar.createPassword, this.props.lang.currentLang.lang, this.props.lang.translatedData));
            });
        }
        else if (this.props.caseListFlag === '1') {
          // Dark title bar
          aemHostClient("/aemData/formData/json_dark-title-bar")
            .then(({ data, status }) => {
              this.props.getDarkTitleBarFlag('0');
              if (!this.props.customer.roleDetails.customer && data.par !== null) {
                this.setState({
                  darkTitlebar: data.par.static_text_darkTitleBar
                })
                this.props.setDarkTitleBarContent(Translations(data.par.static_text_darkTitleBar.caseList, this.props.lang.currentLang.lang, this.props.lang.translatedData), true, Translations(data.par.static_text_darkTitleBar.createCase, this.props.lang.currentLang.lang, this.props.lang.translatedData), "icon icon-add");
              } else {
                this.props.setDarkTitleBarContent(Translations(data.par.static_text_darkTitleBar.yourCase, this.props.lang.currentLang.lang, this.props.lang.translatedData));
              }
            });
        }

        //header login toNextpage
        aemHostClient('/aemData/formData/json_header-page')
          .then(({ data }) => {
            this.setState({
              languagename: [
                `${Translations(data.par.static_text_darkTitleBar.Language, this.props.lang.currentLang.lang, this.props.lang.translatedData)}: ${Translations(data.par.static_text_darkTitleBar.English, this.props.lang.currentLang.lang, this.props.lang.translatedData)} `,
                `${Translations(data.par.static_text_darkTitleBar.Language, this.props.lang.currentLang.lang, this.props.lang.translatedData)}: ${Translations(data.par.static_text_darkTitleBar.Spanish, this.props.lang.currentLang.lang, this.props.lang.translatedData)} `,
                `${Translations(data.par.static_text_darkTitleBar.Language, this.props.lang.currentLang.lang, this.props.lang.translatedData)}: ${Translations(data.par.static_text_darkTitleBar.Bahasa, this.props.lang.currentLang.lang, this.props.lang.translatedData)} `]
            })
            this.props.setHeaderDetails(Translations(data.par.static_text_darkTitleBar.lastLogin, this.props.lang.currentLang.lang, this.props.lang.translatedData),
              Translations(data.par.static_text_darkTitleBar.logOff, this.props.lang.currentLang.lang, this.props.lang.translatedData))
          })

        aemHostClient('/aemData/formData/json_footer-page')
          .then(({ data }) => {
            this.props.setFooterDetails(
              Translations(data.par.static_text_darkTitleBar.termsCondition, this.props.lang.currentLang.lang, this.props.lang.translatedData),
              Translations(data.par.static_text_darkTitleBar.privacy, this.props.lang.currentLang.lang, this.props.lang.translatedData),
              Translations(data.par.static_text_darkTitleBar.cookies, this.props.lang.currentLang.lang, this.props.lang.translatedData))
          })
      });
    if (window.location.pathname === '/login') {
      this.props.setLanguage(lang);
    }
    this.props.setLanguageFlag("true");
    this.props.unBlockUi();
  }

  setLanguageOnEnter = (e) => {
    if (e.keyCode === 13) {
      document.getElementsByClassName("gdoc-header-pdiv-lan")[0].setAttribute("aria-expanded", "false");
      this.setState({
        language: e.target.getAttribute('data-value'),
        arrowIsOpen: false,
        display: 'none'
      });
    }
  }

  //Need to add  this language change dropdown in future

  //start with here3

  /*
  <div className="gdoc-header-pdiv-lan"
  onKeyUp={this.openHanderOnEnter}
  onClick={this.openHander}
  tabIndex="0"
  role="button"
  data-dropdown="gdoc-header-select-lng"
  aria-controls="gdoc-header-select-lng"
  aria-expanded="false" >
  <span className="gdoc-header-selected-country">{this.state.language}</span>
  <span className={this.state.arrowIsOpen === true ? 'icon icon-chevron-up iconFont icon-pos gdoc-header-icondown' : 'icon icon-chevron-down iconFont icon-pos gdoc-header-icondown' }></span>
  </div>
  <ul ref= "gdoc-header-select-lng"
  id="gdoc-header-select-lng"
  className="gdoc-header-custom-dropdown"
  style={display} >
  {
    this.state.languagename
    ? this.state.languagename.map((item,i) =>
    <li tabIndex="0" key={i} data-value={item} onKeyUp={this.setLanguageOnEnter} onClick={this.setLanguage}>{item}</li>)
    : ''
  }
  </ul>
  */

  // end here


  render() {
    const display = {
      display: this.state.display
    }
    let jsx = ''
    if (this.props.auth.isAuthenticated) {
      jsx = (
        <div className="gdoc-headerlist gdoc-header-right">
          {/* {<li>
      <div className="gdoc-header-pdiv">
      <div className="gdoc-header-pdiv-lan"
      onKeyUp={this.openHanderOnEnter}
      onClick={this.openHander}
      tabIndex="0"
      role="button"
      data-dropdown="gdoc-header-select-lng"
      aria-controls="gdoc-header-select-lng"
      aria-expanded="false" >
      <span className="gdoc-header-selected-country">{this.state.languagename[this.state.index]}</span>
      <span className={this.state.arrowIsOpen === true ? 'icon icon-chevron-up iconFont icon-pos gdoc-header-icondown' : 'icon icon-chevron-down iconFont icon-pos gdoc-header-icondown' }></span>
      </div>
      <ul ref= "gdoc-header-select-lng"
      id="gdoc-header-select-lng"
      className="gdoc-header-custom-dropdown"
      style={display} >
      {
        this.state.languagename
        ? this.state.languagename.map((item,i) =>
        <li>
        <div key={i} data-value={item} aria-label={ `${item}`}  onKeyUp={this.setLanguageOnEnter} onClick={this.setLanguage}>{`${item}`}</div></li>)
        : ''
      }
      </ul>
      </div>
    </li>} */}
          <div className="gdoc-header-detailLeft">
            <div className="gdoc-header-detailLeft__content">
              <span className="gdoc-header-loginuser">{`${this.props.auth.userDetails.username}`}</span>
              <p>{`${this.props.headerData.lastLogin !== undefined ? this.props.headerData.lastLogin : ''} ${':'} ${new Date(this.props.auth.lastLogin).toDateString()}`}</p>
            </div>
          </div>
          <div className="gdoc-header-detailRight">
            <button
              className="gdoc-header-btn"
              onClick={this.logout}
            >
              {this.props.headerData.logOff}
            </button>
          </div>
        </div>
      )
    }
    else {
      const languagename = getlanguageToggleValues(this.state.index);
      jsx = (
        <div className="gdoc-headerlist gdoc-header-right">
          {/* {<li>
     <div className="gdoc-header-pdiv">
     <div className="gdoc-header-pdiv-lan"
     onKeyUp={this.openHanderOnEnter}
     onClick={this.openHander}
     tabIndex="0"
     role="button"
     data-dropdown="gdoc-header-select-lng"
     aria-controls="gdoc-header-select-lng"
     aria-expanded="false" >
     <span className="gdoc-header-selected-country">{languagename[this.state.index]}</span>
     <span className={this.state.arrowIsOpen === true ? 'icon icon-chevron-up iconFont icon-pos gdoc-header-icondown' : 'icon icon-chevron-down iconFont icon-pos gdoc-header-icondown' }></span>
     </div>
     <ul ref= "gdoc-header-select-lng"
     id="gdoc-header-select-lng"
     className="gdoc-header-custom-dropdown"
     style={display} >
     {
       languagename
       ? languagename.map((item,i) =>
       <li>
       <div key={i} data-value={item} aria-label={`${item}`}  onKeyUp={this.setLanguageOnEnter} onClick={this.setLanguage}>{`${item}`}</div></li>)
       : ''
     }
     </ul>
     </div>
     </li>} */}
        </div>
      )
    }

    return (
      <div>
        {jsx}
      </div>
    );
  }
}


const mapStateToProps = state => {
  return {
    auth: state.auth,
    customer: state.auth.userDetails,
    caseListFlag: state.getDarkTitleBarFlag,
    newPasswordFlag: state.getDarkTitleBarFlagOnPassword,
    login: state.darkTitleBar.lastLogin,
    lang: state.lang,
    cases: state.cases,
    owningCase: electOwningCase(state.cases),
    headerData: state.headerData
  }
}

const mapDispatchToProps = dispatch => {
  return {
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
    logOutUser: () => {
      dispatch(logOutUser());
    },
    resetStore: () => {
      dispatch(resetStore());
    },
    setLanguage: lang => {
      dispatch(setLanguage(lang));
    },
    setLanguageFlag: flag => {
      dispatch(setLanguageFlag(flag));
    },
    setTranslatedData: translatedData => {
      dispatch(setTranslatedData(translatedData))
    },
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    },
    getDarkTitleBarFlag: flag => {
      dispatch(getDarkTitleBarFlag(flag))
    },
    setHeaderDetails: (...args) => {
      dispatch(setHeaderDetails(...args));
    },
    getDarkTitleBarFlagOnPassword: flag => {
      dispatch(getDarkTitleBarFlagOnPassword(flag));
    },
    setFooterDetails: (...args) => {
      dispatch(setFooterDetails(...args));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RightSection);


// WEBPACK FOOTER //
// ./src/components/layouts/Header/RightSection.js